export default __webpack_public_path__ + "static/broadcastImg3-150d7430d1666c0f3fe273338ceea926.png";